<dx-text-box
  *ngIf="card && card?.dataTypeGroupShowAsHex"
  [value]="value"
  (valueChange)="valueChange.emit($event)"
  [label]="label ?? ''"
  [height]="height"
  [width]="width"
  valueChangeEvent="keyup focusout"
  [placeholder]="translate.instant('PLACEHOLDERS.HEX_VALUE')">
  <dx-validator>
    <dxi-validation-rule
      type="custom"
      [validationCallback]="validateHexValue"
      [message]="translate.instant('VALIDATION.INVALID_HEX')">
    </dxi-validation-rule>
    <dxi-validation-rule
      *ngIf="card.dataTypeGroupMin !== undefined && card.dataTypeGroupMin !== null"
      type="custom"
      [validationCallback]="validateHexMin"
      [message]="translate.instant('VALIDATION.MIN_VALUE', { min: '0x' + card.dataTypeGroupMin.toString(16).toUpperCase() })">
    </dxi-validation-rule>
    <dxi-validation-rule
      *ngIf="card.dataTypeGroupMax !== undefined && card.dataTypeGroupMax !== null"
      type="custom"
      [validationCallback]="validateHexMax"
      [message]="translate.instant('VALIDATION.MAX_VALUE', { max: '0x' + card.dataTypeGroupMax.toString(16).toUpperCase() })">
    </dxi-validation-rule>
  </dx-validator>
</dx-text-box>
